import React from 'react'

import Stepper from 'pmt-ui/Stepper'
import AccountCardDetails from 'pmt-ui/svg-icons/communication/account-card-details'

const Step = {
  USER: 'STEP::USER',
  USER_ACCOUNT: 'STEP::USER_ACCOUNT',
  TEST: 'STEP::TEST',
  TEST2: 'STEP::TEST2',
}

const getComponents = [
  {
    name: 'DateField INLINE',
    definition: (
      <pre>
        {`
          <Stepper
            current={Step.USER}
            steps={[
              {
                key: Step.USER,
                title: 'User',
                icon: (
                  <AccountCardDetails
                    color={'inherit'}
                  />
                ),
                content: (
                  <div>CONTENT</div>
                )
              },
              {
                key: Step.USER_ACCOUNT,
                title: 'User account',
                done: true,
                content: (
                  <div>
                    User account form
                  </div>
                ),
              },
              {
                key: Step.TEST,
                title: 'test',
                done: false,
                content: (
                  <div>
                    test
                  </div>
                ),
              },
              {
                key: Step.TEST2,
                title: 'test 2',
                done: true,
                editable: true,
                content: (
                  <div>
                    test 2
                  </div>
                ),
              },
            ]}
          />
        `}
      </pre>
    ),
    render: (
      <Stepper
        current={Step.USER}
        steps={[
          {
            key: Step.USER,
            title: 'User',
            icon: <AccountCardDetails color={'inherit'} />,
            content: <div>CONTENT</div>,
          },
          {
            key: Step.USER_ACCOUNT,
            title: 'User account',
            done: true,
            content: <div>User account form</div>,
          },
          {
            key: Step.TEST,
            title: 'test',
            done: false,
            content: <div>test</div>,
          },
          {
            key: Step.TEST2,
            title: 'test 2',
            done: true,
            editable: true,
            content: <div>test 2</div>,
          },
        ]}
      />
    ),
  },
]

export default {
  title: 'Stepper',
  components: getComponents,
}
